"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
const NoNotification = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  width: 16,
  height: 16,
  viewBox: "0 0 15 15"
}, props), /*#__PURE__*/_react.default.createElement("path", {
  d: "M9.189 13.061c.529.001.859.571.594 1.027a2.058 2.058 0 0 1-.754.747A2.075 2.075 0 0 1 8.001 15c-.361 0-.716-.094-1.029-.273a2.058 2.058 0 0 1-.754-.747.68.68 0 0 1-.002-.684.687.687 0 0 1 .596-.342h2.377zM1.043 0.611a.473.473 0 0 1 .669 0l12.297 12.297.061.074a.473.473 0 0 1-.656.656l-.074-.061-1.856-1.856H1.121c-.917 0-.917-1.366 0-1.366.76 0 1.376-.612 1.376-1.366V5.564a5.434 5.434 0 0 1 .389-2.124c.031-.076.062-.152.096-.227L1.043 1.28a.473.473 0 0 1 0-.669zM8 0a5.537 5.537 0 0 1 2.13.426 5.508 5.508 0 0 1 1.798 1.211 5.467 5.467 0 0 1 1.186 1.807 5.434 5.434 0 0 1 .389 2.124v3.417c0 .755.616 1.367 1.376 1.367.917 0 .917 1.366 0 1.366h-.902L3.949 1.762c.039-.042.078-.084.118-.125A5.508 5.508 0 0 1 5.866.426 5.537 5.537 0 0 1 8 0z",
  className: "fill"
}));
var _default = exports.default = NoNotification;